import { BasicComboboxEvent } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";

import { BasicComboboxComponent } from "../../../basic/view/BasicComboboxComponent";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2ReportPlayerDialogProperties } from "./Poker2ReportPlayerDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2ReportPlayerDialog extends Poker2Dialog {
    public static NAME: string = "Poker2ReportPlayerDialog";
    private selectionBox: Poker2DynamicCombobox;

    constructor(disp: Container) {
        super(disp);
        this.selectionBox = new Poker2DynamicCombobox(this.reportPlayerDialog.reasoncombobox, Poker2Model.languageData.getTextById("generic_report_player_reason_title"));
    }

    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.reportPlayerDialog.txt_title.text = Poker2Model.languageData.getTextById("generic_report_player_title");
        this.reportPlayerDialog.txt_copy.text = Poker2Model.languageData.getTextById("generic_report_player_copy", [this.reportPlayerDialogProperties.reportPlayerName]);
        this.reportPlayerDialog.txt_reason_title.text = Poker2Model.languageData.getTextById("generic_report_player_reason_title");

        this.reportPlayerDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_report");
        this.reportPlayerDialog.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_cancel");
        this.selectionBox.clearItems();
        var reasonIndex: number = 0;
        let reason: string;

        while (!/^generic_/.test(reason = Poker2Model.languageData.getTextById("generic_report_player_reason_" + reasonIndex))) {
            this.selectionBox.addItem({ label: reason, data: {} });
            reasonIndex++;
        }
        this.selectionBox.selectItemIndex(-1);
        this.selectionBox.updateItemBGs(reasonIndex);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.reportPlayerDialog.btn_ok:
                if (this.selectionBox.selectedId != -1) {
                    var reportString: string = this.selectionBox.selectedId + " - " + this.selectionBox.selectedLabel;
                    BasicModel.smartfoxClient.sendMessage("rpl", [this.reportPlayerDialogProperties.reportPlayerUserId, reportString]);
                }
                this.hide();
                break;
            case this.reportPlayerDialog.btn_close:
            case this.reportPlayerDialog.btn_cancle:
                this.hide();
                break;
        }
    }

    public show(): void {
        this.selectionBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onComboboxChange));
        this.reportPlayerDialog.btn_ok.visible = false;
        this.reportPlayerDialog.btn_cancle.visible = true;
        super.show();
    }

    public hide(): void {
        this.selectionBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onComboboxChange));
        super.hide();
    }

    private onComboboxChange(event: BasicComboboxEvent): void {
        this.reportPlayerDialog.btn_ok.visible = true;
        this.reportPlayerDialog.btn_cancle.visible = false;
    }

    protected get reportPlayerDialogProperties(): Poker2ReportPlayerDialogProperties {
        return this.properties as Poker2ReportPlayerDialogProperties;
    }

    protected get reportPlayerDialog(): Library.PokerInterface.PokerReportPlayer {
        return this.disp as Library.PokerInterface.PokerReportPlayer;
    }
}

import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
